import React, { useState } from 'react';
import { useTheme } from '@mui/material';
import DSModal from '../../../design-system/DSModal';
import DSBox from '../../../design-system/DSBox';
import DSTextField from '../../../design-system/DSTextField';
import DSPrimaryButton from '../../../design-system/DSPrimaryButton';
import DSSecondaryButton from '../../../design-system/DSSecondaryButton';
import { DSTitleTypography } from '../../../design-system/Typography';
import DSValueTypography from '../../../design-system/Typography/DSValueTypography';
import DSCircularProgress from '../../../design-system/DSCircularProgress';

interface ConnectClockModalProps {
  open: boolean;
  onClose: () => void;
  onConnect: (serialNumber: string) => void | Promise<void>;
  isLoading?: boolean;
}

const ConnectClockModal = ({
  open,
  onClose,
  onConnect,
  isLoading = false,
}: ConnectClockModalProps) => {
  const { spacing, palette } = useTheme();
  const [serialNumber, setSerialNumber] = useState('');

  const handleConnect = async () => {
    if (serialNumber.trim()) {
      await onConnect(serialNumber.trim());
    }
  };

  const handleClose = () => {
    setSerialNumber('');
    onClose();
  };

  return (
    <DSModal open={open} onClose={handleClose}>
      <DSBox
        sx={{
          width: spacing(50),
          backgroundColor: palette.background.paper,
          boxShadow:
            '0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px -7px rgba(0, 0, 0, 0.20)',
          padding: spacing(3),
          borderRadius: spacing(3),
          display: 'flex',
          flexDirection: 'column',
          gap: spacing(2),
        }}
      >
        <DSTitleTypography>Connect your Klydoclock</DSTitleTypography>
        <DSValueTypography sx={{ color: palette.text.secondary }}>
          Find your Serial ID on the back of the clock or via Menu → Settings →
          System.
        </DSValueTypography>
        <DSTextField
          placeholder="a2311kv..."
          value={serialNumber}
          fullWidth
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSerialNumber(e.target.value)
          }
          disabled={isLoading}
        />
        <DSBox
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: spacing(2),
            marginTop: spacing(1),
          }}
        >
          <DSSecondaryButton onClick={handleClose} disabled={isLoading}>
            Cancel
          </DSSecondaryButton>
          <DSPrimaryButton
            onClick={handleConnect}
            disabled={!serialNumber.trim() || isLoading}
          >
            {isLoading ? <DSCircularProgress size={20} /> : 'Connect'}
          </DSPrimaryButton>
        </DSBox>
      </DSBox>
    </DSModal>
  );
};

export default ConnectClockModal;
